import { render, staticRenderFns } from "./EducationDialog.vue?vue&type=template&id=7452aeff&scoped=true&"
import script from "./EducationDialog.vue?vue&type=script&lang=js&"
export * from "./EducationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EducationDialog.vue?vue&type=style&index=0&id=7452aeff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452aeff",
  null
  
)

export default component.exports